<template>
  <div id="PersonInfo">
    <div class="mybreadcrumb">
            <i class="iconfont icon-yonghushezhi" style="margin-right:10px;color:#999"></i>
            <el-breadcrumb separator-class="el-icon-arrow-right" >
                <el-breadcrumb-item style="font-size:12px">账号资料</el-breadcrumb-item>
                <el-breadcrumb-item style="font-size:12px">个人信息</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    <div class="data_content">
      <div class="content_left">
        <div class="form_title">基本信息</div>
        <div style="display:flex;justify-content:center">
            <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="120px"
            style="width:520px"
          >
            <el-form-item label="登录账号 :" prop="account">{{account}}</el-form-item>
            <el-form-item label="昵称 :" prop="callName">
              <el-input v-model.trim="ruleForm.callName" placeholder="请输入您的昵称" maxlength="20"></el-input>
            </el-form-item>
            <!--不为企业用户userType=1的时候展示真实姓名-->
            <el-form-item label="真实姓名 :" prop="realName">
              <el-input v-model.trim="ruleForm.realName" placeholder="请输入您的真实姓名" maxlength="20"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱 :" prop="email">
              <el-input v-model="ruleForm.email" placeholder="请输入您的真实邮箱"></el-input>
            </el-form-item>
            <el-form-item label="所在地区 :" prop="selectedOptions">
                  <el-cascader
                      style="width:400px"
                      size="large"
                      :options="caseroptions"
                      v-model="ruleForm.selectedOptions"
                    @change="caserhandleChange">
                </el-cascader>
            </el-form-item>
            <el-form-item label prop="address">
              <el-input v-model="ruleForm.address" placeholder="请输入详细地址" maxlength="200"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div class="form_title">专业信息 <span style="color: red; font-weight: normal;">(注：学生请选择教育用户，填写学校名称。)</span></div>

        <!--教育用户信息表-->
        <div style="display:flex;justify-content:center">
          <el-form
            v-if="userType=='2'"
            :model="ruleForm"
            :rules="educationrules"
            ref="educationForm"
            label-width="120px"
            style="width:520px">
            <el-form-item label="用户类型 :" prop="userType" key="educationFormtype">
                <el-select
                v-model="ruleForm.userType"
                placeholder="请选择用户类型"
                style="width: 100%"
                @change="updateUserType('educationFormtype')"
              >
                <el-option v-for="item in userTypeList"
                :key="item.name"
                :label="item.name"
                :value="item.value"
                :disabled="item.name=='企业用户'"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label=" 所在学校 :" prop="school">
              <el-autocomplete
              ref="companySelect"
              v-model.trim="ruleForm.school"
              style="width: 100%"
              placeholder="请输入学校关键词"
              :trigger-on-focus="false"
              :fetch-suggestions="remoteMethod"
              @hook:mounted="cancalReadOnly"
              @visible-change="cancalReadOnly"
              :maxlength="100">
            </el-autocomplete>


            </el-form-item>
            <el-form-item label="担任职位 ：" prop="studentposition">
                  <el-cascader
                    placeholder="请选择"
                    v-model="ruleForm.studentposition"
                    :options="studentpositionArr"
                    style="width: 100%">
                  </el-cascader>
            </el-form-item>
            <div v-if="ruleForm.studentposition[0]=='学生'">
              <el-form-item label="授课老师姓名" prop="teacherName">
                <el-input v-model="ruleForm.teacherName" placeholder="请输入授课老师姓名" maxlength="20"></el-input>
              </el-form-item>
              <el-form-item label="授课老师电话" prop="teacherPhone">
                <el-input v-model="ruleForm.teacherPhone" placeholder="请输入授课老师电话" maxlength="20"></el-input>
              </el-form-item>
            </div>


            <el-form-item label="专业 :" prop="category" key="educationspeciality">
              <el-select v-model="ruleForm.category" placeholder="请选择专业" style="width: 100%">
                <el-option v-for="item in prefessionList2" :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>

        <!--机构用户信息表-->
        <div style="display:flex;justify-content:center">
            <el-form
              v-if="userType=='3'"
              :model="ruleForm"
              :rules="organizerules"
              ref="organizeForm"
              label-width="120px"
              style="width:520px">
                <el-form-item label="用户类型 :" prop="userType" key="organizeFormtype">
                  <el-select
                  v-model="ruleForm.userType"
                  placeholder="请选择用户类型"
                  style="width: 100%"
                  @change="updateUserType('organizeFormtype')"
                >
                  <el-option v-for="item in userTypeList"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value"
                  :disabled="item.name=='企业用户'"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="所属公司 :" prop="company" key="organizecompany">

                <el-autocomplete
                  ref="companySelect"
                  v-model.trim="ruleForm.company"
                  style="width: 100%"
                  placeholder="请输入公司关键词"
                  :trigger-on-focus="false"
                  :fetch-suggestions="remoteMethod"
                  @hook:mounted="cancalReadOnly"
                  @visible-change="cancalReadOnly"
                  :maxlength="100">
                </el-autocomplete>
              </el-form-item>

              <el-form-item label="所在部门 :" prop="department" key="organizedepartment">
                <el-input v-model="ruleForm.department" placeholder="请输入所在的部门" maxlength="50"></el-input>
              </el-form-item>

              <el-form-item label="担任职位 :" prop="organizeposition" key="organizeposition">
                <el-input v-model="ruleForm.organizeposition" placeholder="请输入担任的职位" maxlength="50"></el-input>
              </el-form-item>

              <el-form-item label="专业 :" prop="discipline" key="organizespeciality">
                <el-select v-model="ruleForm.discipline" placeholder="请选择专业" style="width: 100%">
                  <el-option v-for="item in prefessionList1" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
        </div>


        <!--企业用户信息表-->
        <el-form
          v-if="userType=='1'"
          :model="companyForm"
          :rules="companyrules"
          ref="companyForm"
          label-width="120px"
          style="">
            <div v-if="connectionEnterprises.length">
              <el-tabs v-model="activeName"  type="card" style="margin-top:14px" @tab-click="handletabClick">
                  <el-tab-pane :name="item.enterpriseId" v-for="(item,index) in  companyForm.List" :key="index">
                        <span slot="label"  style="display:flex">
                            <el-tooltip class="itemtip" effect="dark" :content="item.enterpriseName" placement="top-start">
                                <div  style="max-width:200px;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;">
                                    <span >{{item.enterpriseName}}</span>
                                </div>
                            </el-tooltip>
                        </span>

                        <div style="width:100%;display:flex;justify-content:center">
                         <div style="width:520px;padding-top:10px;padding-bottom:10px">
                                <el-form-item label="用户类型 :" prop="userType" key="companykey">
                                    <el-select
                                    v-model="userType"
                                    placeholder="请选择用户类型"
                                    style="width: 100%"
                                    @change="updateUserType('companyFormtype')"
                                    :disabled="true"
                                  >
                                    <el-option v-for="item1 in userTypeList"
                                    :key="item1.name"
                                    :label="item1.name"
                                    :value="item1.value"
                                    ></el-option>
                                  </el-select>
                                </el-form-item>

                                <el-form-item label="姓名/企业昵称 :">
                                  <el-input v-model="item.realName" disabled></el-input>
                                </el-form-item>
                                <el-form-item label="所属公司 :">
                                  <el-input v-model="item.enterpriseName" disabled></el-input>
                                </el-form-item>
                                <el-form-item label="所在部门 :">
                                  <el-input v-model="item.departmentName" disabled></el-input>
                                </el-form-item>
                                <el-form-item label="担任职位 :" :prop="'List.'+ index +'.position'" :rules="companyrules.position">
                                  <el-input v-model.trim="item.position" ></el-input>
                                </el-form-item>
                                <el-form-item label="专业 :"   :prop="'List.'+ index +'.discipline'" :rules="companyrules.discipline">
                                  <el-select v-model="item.discipline" placeholder="请选择专业" style="width: 100%">
                                    <el-option v-for="item2 in prefessionList1" :key="item2" :label="item2" :value="item2"></el-option>
                                  </el-select>
                                </el-form-item>
                            </div>
                      </div>
                  </el-tab-pane>
              </el-tabs>
              </div>
              <div v-else style="text-align:center;padding:40px 0px;font-size:14px;color:#333">所属企业正在认证过程中，认证通过后会显示专业信息</div>
        </el-form>

      </div>

    </div>
    <div class="form_btn">
        <el-button type="primary" @click="fun_editForm(false)" style="width:100px">保存</el-button>
        <el-button  @click="cancleClick" style="width:100px;margin-left:10px">取消</el-button>
    </div>
  </div>
</template>

<script>
import {
  getReginApi,
  searchCompanyListApi,
  getUserInfoApi,
  updateUserInfoApi,
  ModifyUserAndEnterpriseWithIdApi,
  GetUserAndEnterprisesApi
} from "../../js/api";
import Bus from "../../js/bus";
import vue from 'vue'
import { regionData,CodeToText,TextToCode} from 'element-china-area-data'
export default {
  name: "PersonInfo",

  data() {
    return {
      activeName:'',//当前活跃的企业选中
      userType:'',
      educationForm:{//教育用户信息表
          school:'',//学生所在学校
          studentposition:[],//教育用户学生职位
          speciality:'',//学生专业
          userType:'',
      },
      educationrules:{//教育用户表单验证
        school: [{ required: true, message: "请选择学校/机构", trigger:['blur', 'change']}],
        studentposition:[{ required: true, message: '请选择担任职位', trigger: 'change' }],
        speciality:[ { required: true, message: "请选择专业", trigger: "change" }],
        category:[ { required: true, message: "请选择专业", trigger: "change" }],
        userType:[{ required: true, message: "请选择用户类型", trigger: "change" }],
        teacherName:[{ required: true, message: "请输入授课老师姓名", trigger: "blur" }],
        teacherPhone:[{ required: true, message: "请输入授课老师电话", trigger: "blur" }]
      },
      organizeForm:{//机构用户
        userType:'',
        company:'',//所属公司
        department:'',//所在部门
        position:'',//担任职位
        speciality:'',
      },
      organizerules:{//机构用户
        userType:[{ required: true, message: "请选择用户类型", trigger: "change" }],
        company: [{ required: true,message: "请选择企业", trigger: ['blur', 'change']}],
        department:[{ required: false, message: "", trigger: "blur" }],
        position:[{ required: true, message: "请输入担任职位", trigger: "blur" }],
        speciality:[ { required: true, message: "请选择专业", trigger: "change" }],
        discipline:[ { required: true, message: "请选择专业", trigger: "change" }],
        organizeposition:[{ required: true, message: "请输入担任职位", trigger: "blur" }],
      },
      companyForm:{
        List:[],
        userType:'',
        realName:'',
        enterpriseName:'',
        departmentName:'',
        position:'',
        discipline:'',
        enterpriseId:'',
        enterpriseInfoAndUserId:'',
        userId:'',
      },
      companyrules:{
        position:[{ required: true, message: "请输入担任职位", trigger: "blur" }],
        discipline:[ { required: true, message: "请选择专业", trigger: "change" }],
      },
      connectionEnterprises:[],//可以被选择的企业
      caseroptions: regionData,
      userId:localStorage.getItem("userId")?localStorage.getItem("userId"):'',
      account:localStorage.getItem("userAccount")?localStorage.getItem("userAccount"):'',
      passportId:'',
      load: 1,
      isRouterAlive: true,
      userTypeList: [
      {
        name:'企业用户',
        value:1
      }, {
        name:'教育用户',
        value:2
      },
       {
        name:'机构用户',
        value:3
      },
      ],
      total: 3,
      ruleForm: {
        userType:'',
        organizeposition:'',
        selectedOptions:[],
        studentposition:[],
        teacherName:'',
        teacherPhone:''
      },
      studentpositionArr:[
        {
          value: '学生',
          label: '学生',
        },
        {
          value: '教师',
          label: '教师',
          children: [{
            value: '校（院）长',
            label: '校（院）长'
          },
          {
            value: '系主任',
            label: '系主任'
          },
          {
            value: '实验实训室负责人',
            label: '实验实训室负责人'
          },
          {
            value: '教师',
            label: '教师'
          },
          {
            value: '其他',
            label: '其他'
          },
          ]
        },

      ],
      prefessionList: ["建筑", "结构", "给排水", "暖通", "电气", "其他"],
      prefessionList1: ["建筑", "结构", "给排水", "暖通", "电气", "其他"],
      prefessionList2: [
        "土木工程",
        "智能建造",
        "建筑学",
        "城乡规划",
        "交通工程",
        "交通设备与控制工程",
        "工程力学",
        "建设与房地产",
        "市政工程",
        "水利水电工程",
        "地质工程",
        "船舶与海洋工程",
        "港口航道与海岸工程",
        "工程（土木）法学",
        "其他"
      ],
      rules: {
        selectedOptions:[{ required: true, message: '请选择所在地区', trigger: 'change' }],
        studentposition:[{ required: true, message: '请选择担任职位', trigger: 'change' }],
        callName: [{required: true,message: "请输入昵称", trigger: 'blur' }],
        realName: [{ required: true,message: "请输入真实姓名", trigger: 'blur' }],
        email: [
          { required: false, message: "", trigger: "blur" },
          { type: "email", message: "请输入正确的邮箱地址", trigger: "blur" }
        ],
        company: [{ required: true,message: "请选择企业", trigger: ['blur', 'change']}],
        speciality:[ { required: true, message: "请选择专业", trigger: "change" }],
        userType:[{ required: true, message: "请选择用户类型", trigger: "change" }],
        region: [{ required: true, message: "请选择所在地区", trigger: "change" }],
        department:[
          { required: false, message: "", trigger: "blur" },
        ],
        position:
        [
          { required: true, message: "请输入担任职位", trigger: "blur" },
        ],
      },
      provinceArr: [],
      cityArr: [],
      areaArr: [],
      dialogVisible_headPic:false,
      isEdit:true,
    };
  },
  mounted(){
    this.fun_userInfo();
  },
  methods: {
    cancleClick(){
      this.$router.push('/PersonInfoDetail')
    },
    caserhandleChange(value){
      console.log(value)
    },
    handletabClick(tab,event){
    },
    fun_userInfo(){
      let that=this;
      let params={};
      params.userID=this.userId;
      GetUserAndEnterprisesApi(params).then(res => {
        console.log(res)
        if(res.status===200 && res.data.error_code===0){
          const {data}=res.data;

          this.userType=data.type;
          that.formatRegin(data.region);
          that.ruleForm.userType=data.type;
          that.userId=data.id;
          that.passportId=data.passportId;

          for(let key in data){
            vue.set(this.ruleForm,key,data[key])
          }
         if(data.type == 1){//企业用户
            that.connectionEnterprises=data.connectionEnterprises
            that.activeName=that.connectionEnterprises[0].enterpriseId
            this.companyForm.List=data.connectionEnterprises;
         }else if(data.type == 2){//教育用户
              if(data.position){
                that.formatPosition(data.position)
              }
         }else if(data.type==3){//机构用户
            that.ruleForm.organizeposition=data.position
         }

        }else{
          this.$message.error(res.data.error_msg)
        }
      }).catch(
        err => {
          if(err.data && err.data.errorMessages){
                that.$message.error(err.data.errorMessages[0]);
          }else if(err.data){
            that.$message.error(err.data);
          }
        }
      )
    },
    submitForm(formName) {
      let that = this;
      if(this.userType=='2'){
        let formArr=['ruleForm','educationForm']//两个form表单的ref
        this.validForm(formArr)
      }else if(this.userType=='3'){
        let formArr=['ruleForm','organizeForm']//两个form表单的ref
        this.validForm(formArr)
      }else if(this.userType=='1'){
        let formArr=['ruleForm','companyForm']//两个form表单的ref
        this.validForm(formArr)
      }

    },
    validForm(formArr){
      let that=this;
      var resultArr=[] //用来接受返回结果的数组
      var _self=this
      function checkForm(formName) { //封装验证表单的函数
        	var result = new Promise(function(resolve, reject) {
        	_self.$refs[formName].validate((valid) => {
        				if (valid) {
        					resolve();
        				} else { reject(formName) }
        			})
        		})
        	resultArr.push(result) //push 得到promise的结果
      }
      formArr.forEach(item => { //根据表单的ref校验
        	checkForm(item)
      })
      Promise.all(resultArr)
      .then(values => {
        	console.log('表单验证成功')
          this.updateUserInfo();
      })
      .catch( err => {
        	if(err==='ruleForm'){
            return
          }else if(err==='companyForm'){
              let currentCheckFlag=false
              this.companyForm.List.forEach(item=>{
                if(item.enterpriseId==this.activeName){
                    if(!item.position || !item.discipline){
                      currentCheckFlag=true //判断未填写的专业和职位是当前的tabpanel
                    }
                  }
              })
              if(currentCheckFlag){
                return
              }else{
                  for(let i=0;i<this.companyForm.List.length;i++){
                    let itemobj=this.companyForm.List[i]
                    if(!itemobj.position || !itemobj.discipline){
                      this.activeName=itemobj.enterpriseId
                      this.$message.error(`所属企业${itemobj.enterpriseName}专业信息未填写完整！`)
                      break
                    }
                  }
              }
          }
      })
    },
    //企业过滤搜索
    remoteMethod(queryString, cb) {
      if(!queryString){
        return
      }
      let that = this
      let params = {
          word :queryString,
          //token:'bdc33c14-0101-499c-89e4-d50f041b66de'
      }
      searchCompanyListApi(params)
      .then(res => {
        console.log(res)
        if (res.data.reason == 'ok') {
            let list=[];
            for(let v of res.data.result.items){
                list.push({value:v.name})
            }
            let results = list.filter(that.createStateFilter(queryString));
            cb(results);
        }else{
              console.log('无数据')
              cb([]);
          }
        })
      .catch(err => {
          console.log(err)
          cb([]);
      })
    },
    createStateFilter(queryString) {
      return (state) => {
        //return (state.value.indexOf(queryString) !=-1);
        return (state.value);
      };
    },
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { companySelect } = this.$refs;
          const input = companySelect.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    formatPosition(position){
      let that=this;
       try{
          let myposition=position.split('/');
          if(myposition[0]=='学生'){
              that.ruleForm.studentposition=['学生'];
          }else{
              that.ruleForm.studentposition=myposition;
          }
       }
       catch(err){
         console.log(err)
          that.ruleForm.studentposition=[];
          return
       }
    },
    formatRegin(region){
      let that=this;
      let c=region;
      if(!c){
        return
      }
      let arr=c.split('-');
      let myprovince='';
      let mycity='';
      let myarea='';
      try{
        let result=TextToCode[arr[0]].code
      }
      catch(err){
        console.log(err)
        that.ruleForm.selectedOptions=[];
        return
      }
      try{
        //debugger
          if(arr[1]==='北京市'  || arr[1]==='天津市' || arr[1]==='上海市' || arr[1]==='重庆市'){
            myprovince=TextToCode[arr[0]].code;
            mycity=TextToCode[arr[0]]['市辖区'].code;
            if(arr[2]){
                myarea=TextToCode[arr[0]]['市辖区'][arr[2]].code;
                that.ruleForm.selectedOptions=[myprovince,mycity,myarea];
            }else{
              that.ruleForm.selectedOptions=[myprovince,mycity];
            }
          }else{
            if(arr[1]){
              myprovince=TextToCode[arr[0]].code;
              mycity=TextToCode[arr[0]][arr[1]].code;
              if(arr[2]){
                  myarea=TextToCode[arr[0]][arr[1]][arr[2]].code;
                  that.ruleForm.selectedOptions=[myprovince,mycity,myarea];
              }else{
                that.ruleForm.selectedOptions=[myprovince,mycity];
              }
            }else{
              myprovince=TextToCode[arr[0]].code;
              that.ruleForm.selectedOptions=[myprovince];
            }
          }
      }catch(e){
        console.log(e)
        that.ruleForm.selectedOptions=[];
      }
    },
    updateUserInfo(){
        let that=this;
        let params={};

        for(let key in this.ruleForm){
          if(key=='connectionEnterprises'){
            params.connectionEnterprises=JSON.stringify(this.ruleForm.connectionEnterprises)
          }else{
            params[key]=this.ruleForm[key]
          }
        }
        let province='';
        let city='';
        let area='';
        province =CodeToText[that.ruleForm.selectedOptions[0]];
        city =CodeToText[that.ruleForm.selectedOptions[1]];
        area =CodeToText[that.ruleForm.selectedOptions[2]];
        params.region=province + "-" + city + "-" + area ;

        if(this.userType== 1){
          if(that.companyForm.List.length){
            let obj=that.companyForm.List
            params.connectionEnterprises=JSON.stringify(obj)
          }

        }else if(this.userType==2){//教育用户
          params.position=that.ruleForm.studentposition.length==1?'学生':that.ruleForm.studentposition[0]+'/'+that.ruleForm.studentposition[1];

        }else if(this.userType==3){//机构用户
          params.position=that.ruleForm.organizeposition
        }
        ModifyUserAndEnterpriseWithIdApi(params)
        .then(res => {
            console.log(res)
            if(res.status===200 && res.data.error_code===0){
              if(res.data.data==true){
                  this.$message({
                    message: '提交成功！',
                      type: 'success'
                  })
                  Bus.$emit('updateUserInfo',params)
                  that.$router.push('/PersonInfoDetail');
              }else{
                this.$message.error('保存失败！')
              }

            }else{
              this.$message.error(res.data.error_msg)
            }
          })
        .catch(err => {
          if(err.data && err.data.errorMessages){
                that.$message.error(err.data.errorMessages[0]);
            }else if(err.data){
                that.$message.error(err.data);
            }
        })
      },
      updateUserType(mytype){//切换用户类型
          this.userType=this.ruleForm.userType
          this.ruleForm.type=this.ruleForm.userType
      },
      fun_editForm(val){
        this.submitForm('ruleForm');
      },
  }
};
</script>

<style lang="scss" >
#PersonInfo {
  min-height: 100%;
  background: #ffffff;
  box-shadow: 0 4px 20px -5px rgba(217, 217, 217, 0.5);

  .mybreadcrumb{
      padding: 13px 0 13px 20px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #EAEAEA;
      font-size: 12px !important;
    }
  .data_content {
    padding: 0 30px;
    display: flex;
    justify-content: center;
  }
  .form_title {
    font-weight: 700;
    text-align: left;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #0069e0;
    height: 20px;
    line-height: 20px;
    padding-left: 14px;
    border-left: 3px solid #0069e0;
    margin: 20px 0 10px 0;

  }
  .form_btn{
    padding-bottom:40px;
    //margin-bottom: 20px;
  }
  .el-form-item__content {
    text-align: left;
  }
  .content_left {
    width: 100%;
    //width: 525px;
  }
  .content_right {
    width: 40%;
    margin-top: 70px;
    .head_pic{
      width: 100px;
      height: 100px;
      border-radius: 50%;
      margin: 0 auto;
      img{
        width: 100%;
        height: 100%;
      }
    }
  }
  .sbt_item{
    .el-form-item__content{
      display: flex;
    justify-content: space-around;
    }
  }
  .el-input.is-disabled .el-input__inner {
        color: #666;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/AccountData/PersonInfo.vue